import { get } from "../../../apiClient";

const createAutocompleteOptions = (segments) =>
  segments.map(({ id, human_readable_name, name }) => ({
    id,
    label: human_readable_name || name,
  }));

const getServerOptions = async (searchTerm, { limit, offset = 0 } = {}) =>
  get("audience", "/v1/segments", {
    params: { pagination: { limit, offset }, searchTerm },
  }).then(({ result, total_count }) => ({
    options: createAutocompleteOptions(result),
    totalCount: total_count,
  }));

export { createAutocompleteOptions, getServerOptions };
